export default "__VITE_ASSET__DFJXWAmO__"